<template>
  <div class="content-430">
    <div class="class-form-head">课程材料</div>
    <div class="class-form-content">
      <Form
        ref="materialInfo"
        :model="materialInfo"
        label-position="right"
        :label-width="120"
        :rules="materialInfoRule"
        @on-validate="getFormValidate"
      >
        <!-- <FormItem label="是否需材料" prop="reqAttachmentType">
          <RadioGroup v-model="materialInfo.reqAttachmentType">
            <Radio :label="0" :disabled="exsitOrder">不需要</Radio>
            <Radio :label="1" :disabled="exsitOrder">必要</Radio>
            <Radio :label="2" :disabled="exsitOrder">非必要</Radio>
          </RadioGroup>
          <div>
            若必要材料，家长在报名时需支付材料费用，非必要家长可选是否购买
          </div>
        </FormItem> -->
        <template>
          <FormItem
            label="材料商品"
            prop="courseClassOfferRoList"
            class="tip-erro"
          >
            <div style="max-width: 1000px; margin-bottom: 18px">
              <Table
                :columns="tableColumns"
                :data="courseClassOfferRoList"
                border
              >
                <template slot="offerName" slot-scope="{ row, index }">
                  <Input
                    v-model="courseClassOfferRoList[index]['offerName']"
                    :maxlength="50"
                    placeholder="请输入材料费名称"
                    style="width: 120px"
                    :disabled="!isCopy && exsitOrder"
                  ></Input>
                </template>
                <template
                  slot="materialDisplayPrice"
                  slot-scope="{ row, index }"
                >
                  <Input
                    v-model="
                      courseClassOfferRoList[index]['materialDisplayPrice']
                    "
                    placeholder="请输入价格"
                    style="width: 100px"
                    :disabled="!isCopy && exsitOrder"
                  ></Input>
                </template>
                <template slot="offerPrice" slot-scope="{ row, index }">
                  <Input
                    v-model="courseClassOfferRoList[index]['offerPrice']"
                    placeholder="请输入价格"
                    style="width: 100px"
                    :disabled="!isCopy && exsitOrder"
                  ></Input>
                </template>
                <template slot="divideConfigId" slot-scope="{ row, index }">
                  <div @click="handleRowClick(index)">
                    <Select
                      v-model="courseClassOfferRoList[index]['divideConfigId']"
                      style="width: 120px"
                      :transfer="true"
                      :disabled="!isCopy && exsitOrder"
                      @on-change="onBillChange"
                    >
                      <Option
                        v-for="item in billStsList"
                        :key="item.itemId"
                        :value="item.itemId"
                        >{{ item.itemName }}</Option
                      >
                    </Select>
                  </div>
                </template>
                <template slot="reqMaterialType" slot-scope="{ row, index }">
                  <Checkbox
                    v-model="courseClassOfferRoList[index]['reqMaterialType']"
                    :disabled="!isCopy && exsitOrder"
                  ></Checkbox>
                </template>

                <template slot="accountingNum" slot-scope="{ row, index }">
                  <span v-if="row.accountingNum == 0"
                    >按课程商品的课时数分多次结算</span
                  >
                  <span v-else>材料费按{{ row.accountingNum }}次课时结算</span>
                </template>

                <template slot="action" slot-scope="{ row, index }">
                  <span
                    v-if="!(classroomId && !isCopy && exsitOrder)"
                    class="del-btn-430"
                    @click="handleDelete(row, index)"
                    >删除</span
                  >
                </template>
              </Table>
            </div>
            <div>
              <Button
                v-if="!(classroomId && !isCopy && exsitOrder)"
                icon="md-add"
                @click="handleAddBill"
                >新增材料商品</Button
              >
            </div>
            <p>
              请设置材料商品名称，<span>商品被购买后无法修改，</span>家长端可在课程详情页面了解课程材料
            </p>
          </FormItem>
        </template>
      </Form>
    </div>
  </div>
</template>
<script>
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import { checkNum2DecimalsAnd0 } from '@/utils/utils.js';
export default {
  inject: ['AddCommodityInstance'],
  props: {
    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    classroomId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    areaCode: {
      type: String,
      default: ''
    },
    courseOrgId: {
      type: String,
      default: ''
    },
    isCopy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          // 'reqAttachmentType': 0, // 0:不需要 1：必要 2：非必要
          'addCourseClassMaterialRoList': []
          // 'attachmentPriceShow': '', // 材料费用
          // 'attachmentPrice': '', // 材料费用
          // 'attachmentDescribe': '' // 材料说明

        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 课程价格规则
    const validateCoursePrice = (rule, value, callback) => {
      let length = 0;
      const arr = value.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (value === '') {
        callback(new Error('请输入价格'));
      } else if (Number.parseFloat(value) < 0) {
        this.materialInfo.attachmentPriceShow = '';
        callback(new Error('请输入大于或等于0的金额'));
      } else if (length > 2) {
        this.materialInfo.attachmentPriceShow = '';
        callback(new Error('请输入最多两位小数的金额'));
      } else if (arr.length > 2) {
        this.materialInfo.attachmentPriceShow = '';
        callback(new Error('请输入一个小数点'));
      } else {
        callback();
      }
    };

    const validateCourseClassOfferRoList = (rule, value, callback) => {
      const roList = this.courseClassOfferRoList; const isCheck = this.materialInfo.reqAttachmentType != 0;

      if (roList.length != 0 && roList.findIndex(item => { return item.offerName == ''; }) != -1) {
        callback(new Error('请输入材料商品名称'));
      } else if (roList.length != 0 && roList.findIndex(item => { return item.offerPrice === '' || item.offerPrice === null; }) != -1) {
        callback(new Error('请输入材料费用'));
      } else if (roList.length != 0 && roList.findIndex(item => { return item.divideConfigId == ''; }) != -1) {
        callback(new Error('请选择结算分账规则'));
      } else if (roList.length == 0) {
        callback();
      } else {
        let displayResult;
        let result;
        // roList.forEach(item => {
        //   result = checkNum2Decimals(item.offerPrice, '材料商品费用')
        // })
        for (let i = 0, len = roList.length; i < len; i++) {
          displayResult = roList[i].materialDisplayPrice ? checkNum2DecimalsAnd0(roList[i].materialDisplayPrice, '材料费显示价格') : {
            code: 200
          };
          if (displayResult.code != 200) {
            break;
          }
          result = checkNum2DecimalsAnd0(roList[i].offerPrice, '材料商品费用');
          if (result.code != 200) {
            break;
          }
        }
        console.log(displayResult, result, '校验的结果---');
        if ((result && result.error) || (displayResult && displayResult.error)) {
          callback(new Error((result ? result.error : '') || (displayResult ? displayResult.error : '')));
        } else {
          callback();
        }
      }
      // console.log('validateCourseClassOfferRoList', this.courseClassOfferRoList, value)
    };
    return {
      validateCoursePrice,
      validateCourseClassOfferRoList,
      materialInfoRequired: {},
      tableData: [],
      selectRow: -1,
      tableColumns: [{
        title: '材料商品名称',
        slot: 'offerName',
        minWidth: 150

      }, {
        title: '材料费显示价格(元)',
        slot: 'materialDisplayPrice',
        minWidth: 130

      }, {
        title: '材料费用(元)',
        slot: 'offerPrice',
        minWidth: 130
      }, {
        title: '材料账期周期',
        slot: 'accountingNum',
        minWidth: 160
      }, {
        title: '结算分账规则',
        slot: 'divideConfigId',
        minWidth: 150
      }, {
        title: '是否必买材料',
        slot: 'reqMaterialType',
        minWidth: 180,
        align: 'center',
        renderHeader: (h, params) => {
          return h(
            'Tooltip',
            { props: { placement: 'top', transfer: true, 'max-width': '300' } }, // 提示组件的属性
            [
              h('span', [
                h('span', '是否必买材料'), // 列名
                h('Icon', { props: { type: 'ios-alert-outline' } }) // 问号图标
              ]),
              h(
                'span',
                {
                  slot: 'content'
                },
                '勾选后，家长端购买课程时必买该材料'
              ) // 提示内容
            ]
          );
        }
      }, {
        title: '操作',
        slot: 'action',
        width: 80
      }],
      billStsList: [],
      courseClassOfferRoList: [] // 材料名称：offerName，材料费用(分)：offerPrice，分账规则Id：divideConfigId
    };
  },
  computed: {
    materialInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }, // 课程信息
    materialInfoRule() {
      // if (this.materialInfo.reqAttachmentType === 0) {
      //   return {
      //     reqAttachmentType: [
      //       { required: true, message: '请选择是否需材料', type: 'number', trigger: 'change' }
      //     ]
      //   };
      // } else {
      return {
        // reqAttachmentType: [
        //   { required: true, message: '请选择是否需材料', type: 'number', trigger: 'change' }
        // ],
        courseClassOfferRoList: [
          { required: false, validator: this.validateCourseClassOfferRoList, trigger: 'blur,change' }
        ]
        // attachmentPriceShow: [
        //   { required: true, validator: this.validateCoursePrice, trigger: 'blur' }
        // ],
        // attachmentDescribe: [
        //   { required: true, message: '请填写材料名称', trigger: 'blur' }
        // ]
      };
      // }
    }
  },
  watch: {
    'materialInfo.reqAttachmentType'(newVal) {
      if (newVal !== 0) {
        this.$nextTick(() => {
          this.$refs.materialInfo.validateField('courseClassOfferRoList');
          // this.$refs.materialInfo.validateField('attachmentPriceShow');
          // this.$refs.materialInfo.validateField('attachmentDescribe');
        });
      }
      this.dealFormRequire();
    },
    courseClassOfferRoList: {
      handler(newVal, oldVal) {
        const roList = newVal.map(item => { return { offerName: item.offerName, materialDisplayPrice: item.materialDisplayPrice ? item.materialDisplayPrice : '', offerPrice: item.offerPrice * 100, divideConfigId: item.divideConfigId, materialId: item.materialId, reqMaterialType: item.reqMaterialType ? 1 : 0 }; });
        this.$emit('input', {
          // reqAttachmentType: this.materialInfo.reqAttachmentType,
          addCourseClassMaterialRoList: roList
        });
      },
      immediate: true,
      deep: true
    }

    // areaCode(newVal, oldVal) {
    //   if (newVal !== '440114') {
    //     this.materialInfo.reqAttachmentType = 0;
    //   }
    // }
  },
  mounted() {
    //this.$refs.materialInfo.validateField('reqAttachmentType');
    this.$nextTick(() => {
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'materialInfo', '课程材料');
    });
  },
  methods: {
    getFormValidate(prop, status, error) {
      this.materialInfoRequired[prop] = {
        require: this.materialInfoRule[prop] ? this.materialInfoRule[prop][0].required : false,
        status: status
      };
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'materialInfo', '课程材料');
    },
    dealFormRequire() {
      this.materialInfoRequired = {};
      Object.keys(this.materialInfoRule).forEach(item => {
        this.materialInfoRequired[item] = {
          require: !!this.materialInfoRule[item][0].required,
          status: this.materialInfoRequired[item] ? !!this.materialInfoRequired[item].status : false
        };
      });
    },
    // 校验表单
    checkForm() {
      this.$refs.materialInfo.validate();
    },
    getTruePrice() {
      if (this.materialInfo.attachmentPriceShow) {
        this.materialInfo.attachmentPrice = this.materialInfo.attachmentPriceShow * 100;
      } else {
        this.materialInfo.attachmentPrice = '';
      }
    },
    // 删除
    handleDelete(row, index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确定删除？</p>',
        onOk: () => {
          this.courseClassOfferRoList.splice(index, 1);
        },
        onCancel: () => {

        }
      });
    },
    // 获取结算分账规则
    async getLedgerRules() {
      const params = {
        itemType: 2,
        courseTypeKind: null,
        schoolId: this.schoolId,
        orgId: this.courseOrgId,
        offerOrgId: this.courseOrgId,
      };
      const getListApi = this.exsitOrder
        ? courseCenterApi.getListByCondition
        : courseCenterApi.getListByTypeAndOrgIdAndSchId;
      const res = await getListApi(params);
      if (res.status === 200) {
        this.billStsList = res.message;
      }
    },
    setCcOfferRoList(info) {
      this.courseClassOfferRoList = info;
    },
    clearCcOfferRoList() {
      this.courseClassOfferRoList = [];
    },
    // 新增
    handleAddBill() {
      const configId = Array.isArray(this.billStsList) && this.billStsList.length > 0 ? this.billStsList[0]['itemId'] : '';
      this.courseClassOfferRoList.push({
        offerName: '',
        materialDisplayPrice: null,
        offerPrice: null,
        divideConfigId: configId,
        accountingNum: this.getAccountingNum(configId),
        materialId: '',
        reqMaterialType: false
      });
    },
    getAccountingNum(configId) {
      const configKey = this.billStsList.findIndex(item => { return item.itemId == configId; });
      return configKey != -1 ? this.billStsList[configKey]['accountingNum'] : '';
    },
    onBillChange(configId) {
      this.courseClassOfferRoList[this.selectRow]['accountingNum'] = this.getAccountingNum(configId);
      this.courseClassOfferRoList = Object.assign([], this.courseClassOfferRoList);
    },
    handleRowClick(index) {
      this.selectRow = index;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
